import styled from 'styled-components';
import Stack from '@mui/material/Stack';
//theme option
import { themeOptions } from 'styles';
import { commonImage } from 'constants/images';

export const StyledDataGridBoard = styled.div`
  .MuiDataGrid-root {
    border-radius: 0;
  }
  .MuiDataGrid-cell--textLeft {
    justify-content: center;
  }
  .MuiDataGrid-withBorderColor {
    border-color: #dadada;
    border-left: none;
    border-right: none;
  }
  .MuiDataGrid-columnHeadersInner {
    color: #222222;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: ${themeOptions.palette.gray.light};
  }
  .MuiDataGrid-cell {
    max-height: 40px;
    border-left: none;
    border-right: none;
  }
  .MuiDataGrid-footerContainer {
    min-height: 40px;
  }
`;

export const StyledSearchingArea = styled(Stack)`
  display: flex;
  align-items: center;
  padding: 16px 0;
  font-size: 14px;
  font-weight: 400;
  color: ${themeOptions.palette.fontColor.main};
  line-height: 1.5;

  > span {
    margin-right: 10px;
  }

  .MuiSelect-select {
    padding-right: 0;
    /* padding-left: 12px !important; */
  }

  .MuiButton-contained {
    width: 100px !important;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-flow: wrap;
  width: auto;

  .modalBody-top {
    display: flex;
    align-items: center;

    .tf-wrapper {
      width: 20% !important;
    }
  }

  > div {
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  span {
    display: inline-flex;
    width: 171px;
    padding: 9px 16px 9px 0;
  }
  .MuiFormControl-root {
    width: 100%;
    .MuiOutlinedInput-root {
      width: 100%;
    }
  }

  .upload {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #dadada;
    background: #fff;
  }
`;

export const StyledSearchArea2 = styled.div`
  display: flex;
  align-items: center;
  padding: 0 25px;
  font-size: 14px;
  font-weight: 400;
  color: ${themeOptions.palette.fontColor.main};
  line-height: 1.5;

  > div {
    display: flex;
    align-items: center;
    margin: 0px 5px;

    > span {
      margin-right: 10px;
      white-space: nowrap;
    }

    > div {
      display: flex;
      align-items: center;
    }
  }
`;

export const StyledBoardDetailFile = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;

  .attachmentsTitle {
    padding: 9px 12px !important;
    font-weight: 500;
    color: #222;
    background-color: #f8f8f8;
    white-space: nowrap;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada;
  }

  .attachmentsContainer {
    width: 100%;
  }
  .attachmentsWrap {
    position: relative;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 42px;
    padding: 11px 2px;
    border-radius: 6px;
    border: 1px solid #dadada;
    flex-direction: column;
    color: ${themeOptions.palette.gray.default};

    button.deleteButton {
      position: absolute;
      top: 14px;
      left: 5px;
      width: 16px;
      height: 16px;
      background-image: url(${commonImage.modalClose});
      background-size: 100%;
      background-repeat: no-repeat;

      &:disabled {
        opacity: 0;
      }
    }

    button.downloadButton {
      position: absolute;
      right: 15px;
      width: 20px;
      height: 20px;
      background-image: url(${commonImage.fileDownload});
      background-size: 100%;
      background-repeat: no-repeat;
    }

    .custom-file-upload {
      display: block;
      width: 100%;
      cursor: pointer;
      color: #adadad;

      b {
        color: #b38b3a;
      }
    }

    /* Hide the default file input */
    #file-upload {
      display: none;
    }

    > div {
      /* padding-left: 50px; */
      padding-left: 24px;
      position: relative;
      margin: 10px 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    p.empty {
      color: ${themeOptions.palette.gray.default};
    }

    p {
      color: ${themeOptions.palette.gray.dark};

      span {
        display: inline-block;
        width: auto;
        padding: 0;
        margin-left: 4px;
        color: ${themeOptions.palette.gray.default};
      }
    }

    .uploadButton {
      width: 100%;
      border: none;
      padding: 3px;
    }
  }

  .downloadWrapper {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 10px 10px 10px 50px;
    position: relative;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
    background: #fff;

    > div {
      margin: 10px 0;
      text-align: left;
      button {
        position: absolute;
        left: 15px;
        width: 20px;
        height: 20px;
        background-image: url(${commonImage.modalClose});
        background-size: 100%;
        background-repeat: no-repeat;
      }
    }
  }
`;

export const StyledReply = styled.div`
  .wrap {
    width: inherit;

    .commentWrap {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: baseline;
      width: 100%;
      padding: 11px 14px;
      border-radius: 6px;
      border: 1px solid #dadada;

      .author {
        strong {
          color: ${themeOptions.palette.gray.default};
        }
      }

      .content {
        display: inline-flex;
        align-items: center;
        font-weight: 400;
        word-break: break-word;
        word-wrap: break-word;
        width: 100%;

        > div:nth-of-type(1) {
          width: 100%;
          margin-right: 10px;
        }
        > * {
          margin-bottom: 0;

          span {
            display: none;
          }
        }
      }

      .border {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        width: 100%;
        border-bottom: 1px solid #dadada;

        &:last-of-type {
          border-bottom: none;
        }

        > * {
          margin: 10px 0;
        }
      }
    }

    .replyWrap {
      display: flex;
      gap: 12px;

      div:nth-of-type(1) {
        width: 100%;
        margin-bottom: 0;

        > span {
          display: none;
        }
      }
    }

    > div {
      display: flex;
      align-items: center;
    }

    p {
      font-size: 14px;
      line-height: 18px;
      color: ${themeOptions.palette.gray.dark};

      span {
        display: inline-block;
        width: auto;
        padding: 0;
        margin-left: 4px;
        color: ${themeOptions.palette.gray.default};
      }
    }

    .uploadButton {
      width: 100%;
      border: none;
      padding: 3px;
    }

    .downloadButton {
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 28px;
        height: 28px;
      }
    }
  }
`;

export const findStyle = (category: 'MASTER' | 'IMPORTANT' | 'GENERAL') => {
  const basicStyle = {
    width: '106px',
    height: '28px',
    padding: '3px 0px',
    gap: '4px',
    borderRadius: '4px',
    color: 'white',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: '500',
    fontSize: '14px'
  };
  if (category === 'MASTER')
    return {
      ...basicStyle,
      backgroundColor: '#DAAF4F'
    };
  if (category === 'GENERAL')
    return {
      ...basicStyle,
      backgroundColor: '#ACD27A'
    };
  if (category === 'IMPORTANT')
    return {
      ...basicStyle,
      backgroundColor: '#CA4757'
    };
};
